export const main = 'rgba(29,100,57,.7)';
export const dark = '#343A40';
export const projectMobileSize = 300;
